export default __webpack_public_path__ + "static/media/crimson-space.9c08f582d4e98f525633712139a78f60.svg";